import { todayLocalYMD } from './dateFormat'

// MWA-392 — an applied date is the day the application was submitted. When a
// client approves an application, or staff confirm one was submitted, the job
// moves into Applied and gets that day. The server fills the day in itself when
// it is not told, but in UTC, which is already tomorrow for a US evening; the
// person acting knows their own date, so they send it.

// The decisions that start an application. A decline (Not Interested, Not
// Suitable) archives the job and moves nothing into Applied.
const APPROVING_DECISIONS = ['apply_on_behalf', 'self_apply']

export function isApprovingDecision(decision: string | undefined): boolean {
  return decision !== undefined && APPROVING_DECISIONS.includes(decision)
}

/** An update that records a decision, carrying today's local date when it starts an application. */
export function withDecisionDate<T extends { applyDecision?: string }>(
  update: T,
  today: string = todayLocalYMD()
): T & { applicationDate?: string } {
  return isApprovingDecision(update.applyDecision) ? { ...update, applicationDate: today } : update
}
